module.exports = __webpack_public_path__ + "static/media/6.823a638d.png";